export default "__VITE_ASSET__5gHinZ7d__"